export default __webpack_public_path__ + "static/media/pen.dd2d50fb.png";